export enum GiftCardTransactionType {
  Purchase = "Purchase",
  Reload = "Reload"
}

export enum GiftCardTransactionChannel {
  IN_RESTAURANT = "IN_RESTAURANT",
  DIGITAL = "DIGITAL"
}

/** Schema type for loadGiftCard mutation input (replaces AddGiftCardInput) */
export type LoadGiftCardInput = {
  cardNumber: string;
  pin: string;
};

/** loadGiftCard mutation response; true on success. Balance available via userAccounts (WorldPay) after refetch. */
export type LoadGiftCardPayload = boolean;

export type UserAccountsResponse = {
  accounts: Array<{
    giftCard: {
      cardType: string;
      currentBalance: number;
      last4: string;
    };
  }>;
};

export type GetGiftCardBalancePayload = {
  currentBalance: number;
};

export type TransferInquiryInput = {
  cardNumber: string;
  pin?: string;
};

export type GetGiftCardDataPayload = {
  giftCardData: {
    cardNumber: string;
    accountIdentifier: string;
    pin?: string;
  };
};

export type GiftCardTransaction = {
  date: string;
  type: GiftCardTransactionType;
  amount: number;
  transactionChannel: GiftCardTransactionChannel;
};

export type GetGiftCardTransactionHistoryPayload = {
  transactions: GiftCardTransaction[];
};
